module.exports = __webpack_public_path__ + "img/just_logo_dark3.defb358d.png";